import React, { useEffect } from "react";
import {
  Grid, Paper, TextField, InputAdornment, Chip,
  Button,
  Autocomplete,
  Typography,
  capitalize,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Box
} from "@mui/material";
import {
  PointOfSale as PosIcon,
} from "@mui/icons-material";

import { fetchMonedas, fetchClientes } from "../../../../utils/generalsFetch";
import { formatIdentification, formatNumberWithCommas } from "../../../../utils/generalFunctions";
import MetodoDePagoDialog from "../components/metododepagodialog";
import AlertMessageDialog from "../../../../components/Dialogs/alertMessageDialog";
import { StyledCellHeader } from "../../../../components/StyledCellHeader";
import { impresionrecibopagoinicial } from "../../prestamos/pagos/imprimirpagos";


export default function CargosScreen(props) {
  const [monto, setMonto] = React.useState(parseInt(props.selectedCargo.montoFijo).toString());
  const [moneda, setMoneda] = React.useState("RD$");
  const [productoSelected, setProductoSelected] = React.useState(null);
  const [clientes, setClientes] = React.useState([]);
  const [clienteSelected, setClienteSelected] = React.useState(null);
  const [clienteInputValue, setClienteInputValue] = React.useState("");   
  const [nombreCliente, setNombreCliente] = React.useState("");
  const [descripcion, setDescripcion] = React.useState("");
  const [openMetodoDePago, setOpenMetodoDePago] = React.useState(false);
  const [productos, setProductos] = React.useState([]);
  const [cargoPagosHistorial, setCargoPagosHistorial] = React.useState([]);
  const [alertOpen, setAlertOpen] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [alertTitle, setAlertTitle] = React.useState("");
  const [alertSeverity, setAlertSeverity] = React.useState("success");

  useEffect(() => {
    fetchMonedas({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      const monedaEncontrada = data.find((moneda) => moneda.value == "1");
      setMoneda(monedaEncontrada || { label: "RD", value: "1" });
    });
    fetchClientes({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      setClientes(data);
    });
    fetchProductos();
    fetchCargoPagosHistorial();
    }, []);

  const fetchCargoPagosHistorial = async () => {
    var fecha_desde = new Date().toISOString().split('T')[0];
    var fecha_hasta = new Date().toISOString().split('T')[0];
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/gestion_cargos/pagos/${props.selectedCargo.id}?idcompany=${localStorage.getItem('idcompany')}&fecha_desde=${fecha_desde}&fecha_hasta=${fecha_hasta}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
        'X-company-ID': localStorage.getItem('idcompany')
      }
    });
    const data = await response.json();
    setCargoPagosHistorial(data);
  }

  const fetchProductos = async () => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/categorias_cargos/productos?idcompany=${localStorage.getItem('idcompany')}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        },
        body: JSON.stringify({
          categorias: JSON.parse(props.selectedCargo["categoria_producto"]).map(c => c.id)
        })
      }
    );
    const data = await response.json();
    setProductos(data["productos"]);
  }

  const handleClienteChange = (val) => {
    if(val){
      setNombreCliente(JSON.parse(val.campos)?.["1"]);
      setClienteInputValue(val.identificacion);
    }
    else{
      setNombreCliente("");
      setClienteInputValue("");
    }
    setClienteSelected(val);
    
  };

  const handleClienteInputChange = (event, newInputValue,reason) => {
    if (reason === 'input') {
      const formattedValue = formatIdentification(newInputValue);
      setClienteInputValue(formattedValue);
      handleClienteSearch(formattedValue);
    } else if (reason === 'clear') {
      setClienteInputValue('');
      handleClienteSearch('');
    }
  }

  const handleClienteSearch = (val) => {
    var cliente = clientes.find(cliente => cliente.identificacion === val);
    if(cliente) {
      setClienteSelected(cliente);
      setNombreCliente(JSON.parse(cliente.campos)?.["1"]);
    } else {
      setClienteSelected(null);
      setNombreCliente("");
    }
  }

  const handleConfirm = async(paymentData) => {
    if (!monto || parseFloat(monto) <= 0) return;

    var cargos = [];
    cargos.push({
      id_cargo: props.selectedCargo.id,
      monto: monto,
      cliente: {"nombre": nombreCliente, "identificacion": clienteInputValue},
      id_producto: productoSelected?.id_producto,
      id_prestamo: '',
      descripcion: descripcion,
      id_sucursal: localStorage.getItem('id_sucursal'),
      created_by: localStorage.getItem('id'),
      idcompany: localStorage.getItem('idcompany'),
      metodo_pago: paymentData.payments.map(payment => ({
        method: payment.method,
        amount: payment.amount,
        reference: payment.reference
      }))
    });
    
    let url = `${process.env.REACT_APP_SERVER_URL}/api/gestion_cargos/pagar`;
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id')
        },
        body: JSON.stringify({
          cargos: cargos
        })
      });
      
      if (!response.ok) {
        const error = await response.json();
        console.log(error);
        setAlertTitle("Error");
        setAlertMessage(error.message || "Error al procesar el pago del cargo");
        setAlertSeverity("error");
        setAlertOpen(true);
        return;
      }
      
      var data = await response.json();
      setAlertTitle("Éxito");
      setAlertMessage("Pago del cargo procesado correctamente");
      setAlertSeverity("success");
      setAlertOpen(true);
      handleClose();
      setOpenMetodoDePago(false);
      impresionrecibopagoinicial(nombreCliente,localStorage.getItem('nombre_compania'),"Pago de "+props.selectedCargo.nombre,new Date().toLocaleDateString(),monto,productoSelected["id_producto"],[{concepto:props.selectedCargo.nombre,total:monto}]);
    
    }
    catch (error) {
      console.log(error);
      setAlertTitle("Error");
      setAlertMessage("Error de conexión al procesar el pago");
      setAlertSeverity("error");
      setAlertOpen(true);
    }  
  

  };

  const handleClose = () => {
    setMonto("");
    setDescripcion("");
    setProductoSelected(null);
    setNombreCliente("");
    setClienteInputValue("");
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  return (
    <Grid container spacing={2} >

      <Grid item size={6}>
      <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, bgcolor: "white", minHeight: 450}}>
        <Typography fontWeight={600} variant="h6" textAlign={"left"} padding={2}>
          Historial de Pagos de {props.selectedCargo.nombre}
        </Typography>

        {(cargoPagosHistorial && cargoPagosHistorial.length > 0) ? (
          
            <TableContainer component={Paper} sx={{mt: 2}}>
            <Table size="small">
                <TableHead>
                 <TableRow>
                   <StyledCellHeader>Fecha</StyledCellHeader>
                   <StyledCellHeader>Monto</StyledCellHeader>
                   <StyledCellHeader>Cliente</StyledCellHeader>
                   <StyledCellHeader>Descripción</StyledCellHeader>
                   <StyledCellHeader>Método de Pago</StyledCellHeader>
                 </TableRow>
               </TableHead>
              <TableBody>
                {cargoPagosHistorial.map((pago, idx) => (
                  <TableRow key={pago.id || idx}>
                    <TableCell>
                      {pago.created_at ? new Date(pago.created_at).toLocaleString() : "-"}
                    </TableCell>
                    <TableCell>
                      {pago.monto ? pago.monto.toLocaleString("es-DO", { style: "currency", currency: pago.moneda || "DOP" }) : "-"}
                    </TableCell>
                    <TableCell>
                      {pago.cliente
                        ? (JSON.parse(pago.cliente).nombre || JSON.parse(pago.cliente).identificacion || "-")
                        : "-"}
                    </TableCell>
                    <TableCell>
                      {pago.descripcion || "-"}
                    </TableCell>
                    <TableCell>
                      {JSON.parse(pago.metodo_pago).map((metodo, idx) => (
                        <Chip key={idx} label={metodo.method} size="small" sx={{mr: 1}}/>
                      ))}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            </TableContainer>
          
          
        ) : (
            <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="100%"
            minHeight={300}
            sx={{
              border: '1px dashed #bdbdbd',
              borderRadius: 2,
              bgcolor: '#fafafa',
              p: 4,
              mt: 4
            }}>
            <Typography variant="h5" color="text.secondary" gutterBottom>
              No hay pagos de {props.selectedCargo.nombre} registrados el dia de hoy.
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Cualquier pago de {props.selectedCargo.nombre} registrado el dia de hoy se mostrara aqui.
            </Typography>
          </Box>


        )}
        </Paper>
      </Grid>
        
      <Grid item size={6} sx={{ display: "flex", justifyContent: "center" }}>
        <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, bgcolor: "white", width: "100%",}}>
          <Grid container spacing={2} mb={2} padding={2}>
            <Grid item size={8}>
              <Typography variant="h5" fontWeight={700} textAlign={"left"}>
                Pago de {props.selectedCargo.nombre}
              </Typography>
            </Grid>
            <Grid item size={4}>
              <Chip
                size="small"
                icon={<PosIcon />}
                color={props.shiftOpen ? "success" : "default"}
                label={`Caja: ${props.shiftOpen ? "Disponible" : "Cerrada"}`}
                variant={props.shiftOpen ? "filled" : "outlined"}
              />
            </Grid>            

            <Grid item xs={12} mt={2}>
              <Typography fontWeight={600} variant="h6">
                Datos del cliente
              </Typography>
            </Grid>
            <Grid item size={12}>
            <Autocomplete
                options={clientes}
                getOptionLabel={(option) => option.identificacion || ""}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Clientes" fullWidth />
                )}
                onChange={(e, val) => handleClienteChange(val)}
                onInputChange={(e, newInputValue, reason) => {
                  handleClienteInputChange(e, newInputValue, reason);
                }}
                inputValue={clienteInputValue}
                value={clienteSelected}
              />
            </Grid>
            <Grid item size={12}>
              <TextField
                fullWidth
                placeholder="Nombre del cliente"
                value={nombreCliente}
                onChange={(e) => setNombreCliente(e.target.value)}
                disabled={!!clienteSelected}
              />
            </Grid>

            <Grid item size={12}>
                <Typography
                variant="h6"
                fontWeight={700}
                textAlign={"left"}
                >
                Seleccionar Productos
                </Typography>
            </Grid>
            <Grid item size={12}>
                <Autocomplete
                options={productos}
                getOptionLabel={(option) => option.id_producto}
                renderInput={(params) => (
                    <TextField {...params} placeholder="Productos disponibles" fullWidth />
                )}
                onChange={(e, val) => {
                    setProductoSelected(val);
                }}
                renderOption={(props, option) => (
                    <li {...props}>
                        <Typography variant="body2" fontWeight={600} textAlign={"left"}>
                            {option.id_producto}
                        </Typography>
                        <Chip label={option.categoria_name} size="small" sx={{ml: 1}}/>
                    </li>
                )}
                fullWidth
                />
            </Grid>
            {(clienteSelected || nombreCliente !== "") && productoSelected &&
                  JSON.parse(productoSelected["categoria_fields"]).map((campo, index) => {
                    var value = JSON.parse(productoSelected["campos"])[campo.id];
                    return (
                      <Grid item size={4} key={campo.id}>
                        <Typography
                          fontWeight={600}
                          textAlign={"left"}
                          mx={1}
                        >
                          {campo.id == "id"
                            ? capitalize(campo.alias)
                            : capitalize(campo.name)}
                        </Typography>
                        <TextField
                          slotProps={{
                            input: {
                              startAdornment:
                                campo.type === "monto" ? (
                                  <InputAdornment position="start">
                                    {moneda?.label || "RD"}$
                                  </InputAdornment>
                                ) : null,
                            },
                          }}
                          fullWidth
                          value={
                            campo.type == "monto"
                              ? formatNumberWithCommas((value || "").toString())
                              : value || ""
                          }
                          disabled={true}
                        />
                      </Grid>
                    );
                  })}

            {(clienteSelected || nombreCliente !== "") && productoSelected && (
              <>
                <Grid item size={12}>
                    <Typography variant="body2" mt={2} textAlign={"left"}>
                    Ingrese el monto del cargo que desea cobrar:
                    </Typography>
                </Grid>
                <Grid item size={12}>
                    <TextField
                    fullWidth
                    placeholder="Monto del cargo"
                    value={formatNumberWithCommas(monto || "")}
                    onChange={(e) => {
                        setMonto(e.target.value.replace(/[^0-9.]/g, ""));
                    }}
                    InputProps={{
                        startAdornment: (
                        <InputAdornment position="start">RD$</InputAdornment>
                        ),
                    }}
                    />
                </Grid>
                <Grid item size={12}>
                    <TextField
                    fullWidth
                    placeholder="Descripción"
                    value={descripcion}
                    onChange={(e) => {
                        setDescripcion(e.target.value);
                    }}
                    />
                </Grid>
              </>
            )}
        
            <Grid item size={12} mt={2} display="flex" justifyContent="flex-end">
              <Button onClick={() => {window.location.reload()}} color="inherit" sx={{ mr: 2 }}>
                Cancelar
              </Button>
              <Button
                sx={{ fontWeight: "bold" }}
                onClick={() => setOpenMetodoDePago(true)}
                color="primarybutton"
                variant="contained"
                disabled={!monto || parseFloat(monto) <= 0 || !productoSelected || (!clienteSelected && nombreCliente === "") || !props.shiftOpen}
              >
                Confirmar
              </Button>
            </Grid>
          </Grid>
          
          <MetodoDePagoDialog
            open={openMetodoDePago}
            onClose={() => setOpenMetodoDePago(false)}
            onConfirm={handleConfirm}
            amount={monto}
            title={`Pago de ${props.selectedCargo.nombre}`}
            description="Seleccione el método de pago para el cargo"
            showAmount={true}
            defaultMethod="efectivo"
          />

          <AlertMessageDialog
            open={alertOpen}
            setOpen={setAlertOpen}
            handleClose={handleAlertClose}
            title={alertTitle}
            message={alertMessage}
            severity={alertSeverity}
          />

        </Paper>
      </Grid>
    </Grid>
  );
}
